
import { useState } from "react";
import { Opportunity } from "@/types/database-extensions";
import { useAuth } from "@/contexts/AuthContext";
import { useFetchOpportunities } from "./useFetchOpportunities";
import { useOpportunityActions } from "./useOpportunityActions";
import { useOpportunityForm } from "./useOpportunityForm";

export const useOpportunityManagement = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentOpportunity, setCurrentOpportunity] = useState<Partial<Opportunity>>({
    title: "",
    description: "",
    organization: "",
    deadline: "",
    application_url: "",
    location: "",
    type: "",
  });
  
  const { user } = useAuth();
  
  const { 
    opportunities, 
    loading,
  } = useFetchOpportunities();

  const { 
    handleCreate,
    handleSubmit,
    handleInputChange,
    isSubmitting,
  } = useOpportunityForm({
    currentOpportunity,
    setCurrentOpportunity,
    setIsDialogOpen,
    user
  });

  const {
    handleDelete,
    handleEdit,
    isDeleting
  } = useOpportunityActions({
    setCurrentOpportunity,
    setIsDialogOpen,
    user
  });

  return {
    opportunities,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    isSubmitting,
    isDeleting,
    currentOpportunity,
    handleInputChange,
    handleCreate,
    handleEdit,
    handleSubmit,
    handleDelete,
  };
};
